const $tabs = $('.tabs');
if( $tabs.length ){
	$tabs.each(function(){
		let $parent = $(this);
		// .panels groups the inner blocks so we can create tab panels out of them
		let $panels = $parent.find('.panels').children('div');
		let $nav = $parent.find('.tabs-nav');
		$panels.each(function(i){
			$(this).addClass('tabs-panel').attr('role','tabpanel');
			if (i > 0) {
				$(this).prop('hidden', true);
			}
			$nav.append(`<button
				role="tab"
				id="tab-${$parent.attr('id')}-${i}"
				tabindex="${i === 0 ? 0 : -1}"
				aria-selected="${i === 0 ? 'true' : 'false'}"
				aria-controls="${$(this).attr('id')}">
				${$(this).data('tab-label')}
			</button>`);
			$(this).detach().insertAfter($nav);
		});
		// once we're done, remove .panels so we have the correct structure for the UI js below
		$parent.find('.panels').remove();
	});
}
// https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/tab_role#example
window.addEventListener("DOMContentLoaded", () => {
	const tabs = document.querySelectorAll('[role="tab"]');
	const tabList = document.querySelector('[role="tablist"]');

	if (! tabs.length) return;

	// Add a click event handler to each tab
	tabs.forEach((tab) => {
		tab.addEventListener("click", changeTabs);
	});

	// Enable arrow navigation between tabs in the tab list
	let tabFocus = 0;

	tabList.addEventListener("keydown", (e) => {
		// Move right
		if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
			tabs[tabFocus].setAttribute("tabindex", -1);
			if (e.key === "ArrowRight") {
				tabFocus++;
				// If we're at the end, go to the start
				if (tabFocus >= tabs.length) {
					tabFocus = 0;
				}
				// Move left
			} else if (e.key === "ArrowLeft") {
				tabFocus--;
				// If we're at the start, move to the end
				if (tabFocus < 0) {
					tabFocus = tabs.length - 1;
				}
			}

			tabs[tabFocus].setAttribute("tabindex", 0);
			tabs[tabFocus].focus();
		}
	});
});

function changeTabs(e) {
	const target = e.target;
	const parent = target.parentNode;
	const grandparent = parent.parentNode;

	// Remove all current selected tabs
	parent
		.querySelectorAll('[aria-selected="true"]')
		.forEach((t) => t.setAttribute("aria-selected", false));

	// Set this tab as selected
	target.setAttribute("aria-selected", true);

	// Hide all tab panels
	grandparent
		.querySelectorAll('[role="tabpanel"]')
		.forEach((p) => p.setAttribute("hidden", true));

	// Show the selected panel
	grandparent.parentNode
		.querySelector(`#${target.getAttribute("aria-controls")}`)
		.removeAttribute("hidden");

	const event = new Event("tabChange");
	document.body.dispatchEvent(event);
}